import { useRecoilValue, useResetRecoilState } from "recoil";
import {
  contactAtom,
  estimatedProductPriceAtom,
  requirementAtom,
  sourceAtom,
  uploadFileAtom,
  workloadAtom,
  worksAtom,
} from "src/recoil/atoms/textTranslation";
import { useMutation } from "@apollo/client";
import { CREATE_DOCUMENT_QUOTATION_REQUEST } from "src/api/document";
import { langKeyType, languageType } from "utils/textTranslation";
import { useState } from "react";
import { postIntakeDeal } from "src/api/service/crm";
import { buildIntakeDealPayload } from "src/utils/crm";
import { logging } from "src/utils/logger";

const useTextTranslation = () => {
  const [createEstimateRequest] = useMutation(
    CREATE_DOCUMENT_QUOTATION_REQUEST,
  );

  const contact = useRecoilValue(contactAtom);
  const estimatedProductPrice = useRecoilValue(estimatedProductPriceAtom);
  const requirement = useRecoilValue(requirementAtom);
  const source = useRecoilValue(sourceAtom);

  const workload = useRecoilValue(workloadAtom);
  const works = useRecoilValue(worksAtom);
  const uploadFile = useRecoilValue(uploadFileAtom);

  const resetUploadFile = useResetRecoilState(uploadFileAtom);
  const resetWorkload = useResetRecoilState(workloadAtom);

  const [isError, setIsError] = useState(false);

  const calculatedWorks = () => {
    const { sourceLanguage, targetLanguages } = works;

    const convertSourceLanguage = languageType[sourceLanguage];

    // @ts-ignore
    return targetLanguages.map((target: langKeyType) => {
      return {
        sourceLanguage: { id: convertSourceLanguage },
        targetLanguage: { id: languageType[target] },
      };
    });
  };

  const handleSubmitEstimate = async () => {
    // call createEstimateRequest mutation
    const estimateData = {
      request: {
        contact,
        estimatedProductPrice,
        requirement: {
          ...requirement,
          expectedDeliveryDate: requirement.expectedDeliveryDate?.toISOString(),
        },
        source: { files: source.files, type: source.type },
        workload: { ...workload, unit: workload.unit },
        works: calculatedWorks(),
      },
    };

    const response = await createEstimateRequest({ variables: estimateData });

    if (response) {
      const quotationRequestId =
        response.data?.createDocumentQuotationRequest?.quotationRequest?.id;

      // CRM 리드(deal) 전송 - 부가 기능이므로 실패해도 견적 플로우는 진행
      if (quotationRequestId) {
        try {
          await postIntakeDeal(
            buildIntakeDealPayload({
              quotationRequestId,
              contact,
              estimatedProductPrice,
              requirement,
              source,
              works,
              uploadFile,
            }),
          );
        } catch (e) {
          logging(
            "error",
            JSON.stringify({
              location: "userInfo",
              type: "crm",
              detail: "fail to post CRM intake deal",
            }),
          );
        }
      }

      alert("성공적으로 견적이 작성되었습니다.");
      return true;
    } else {
      return setIsError(true);
    }
  };

  const resetFileData = () => {
    resetUploadFile();
    resetWorkload();
  };

  return {
    handleSubmitEstimate,
    resetFileData,
    isError,
    setIsError,
  };
};

export default useTextTranslation;
